var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-label": "check mark"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.072 7.46-5.81 7.749a.382.382 0 0 1-.273.148.383.383 0 0 1-.294-.11l-3-3a1.125 1.125 0 0 0-1.59 1.591l3 3.001a2.627 2.627 0 0 0 3.955-.28l5.812-7.75a1.124 1.124 0 0 0-.226-1.574 1.126 1.126 0 0 0-1.575.225Z"
  })));
};
export default SvgCheckMark;